"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBRolesPermissionHelperService = void 0;
const _ = require("underscore");
const bbroles_service_1 = require("../../shared/services/bbroles.service");
const account_service_1 = require("../../shared/services/account.service");
class BBRolesPermissionHelperService {
    constructor(rolesService, accountService) {
        this.rolesService = rolesService;
        this.accountService = accountService;
        this.accountService.getAccountDetails().subscribe((account) => {
            this.isBusinessAccount = account.businessAccount;
        });
    }
    getRoles(roles, rolesInfo) {
        const finalRole = _.intersection(roles, rolesInfo.Role);
        if (finalRole.length > 0) {
            return true;
        }
        else {
            if (roles.indexOf('No Role') > -1) {
                return true;
            }
            return false;
        }
    }
    getRolesPermission(roles, cacheResponse) {
        // only check roles for business accounts
        if (!this.isBusinessAccount) {
            return true;
        }
        this.rolesService.getRolesAndPermissions(cacheResponse).subscribe((rolesInfo) => {
            this.accountRoles = rolesInfo;
            this.isBbRole = this.getRoles(roles, rolesInfo);
        });
        return this.isBbRole === undefined ? true : this.isBbRole;
    }
}
exports.BBRolesPermissionHelperService = BBRolesPermissionHelperService;
//# sourceMappingURL=roles-helper.service.js.map